import React from 'react';
import styled from 'styled-components';
import { Switch, textStyles, token, TruncatedText } from '@bynder/design-system';
import { IconSmart } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

interface Props {
	isNLSSearchOn: boolean;
	setIsNLSSearchOn: React.Dispatch<React.SetStateAction<boolean>>;
	spotlightInputRef: React.RefObject<HTMLInputElement>;
}

// FIX: TODO: This uses some copy-pasting from the Design System's ListItem component. Once it allows for custom background colors, we can use it instead of reimplementing it
export function BannerNLS({ isNLSSearchOn, setIsNLSSearchOn, spotlightInputRef }: Props) {
	const { translate } = useTranslate();

	const toggleNLSAndFocusSpotlight = (event?: React.MouseEvent) => {
		event?.stopPropagation(); // Otherwise, it counts as a "click outside the spotlight input" and it closes the dropdown
		setIsNLSSearchOn((prev) => !prev);
		spotlightInputRef.current?.focus();
	};

	return (
		<ItemStyled
			onClick={toggleNLSAndFocusSpotlight}
			onKeyDown={(event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					toggleNLSAndFocusSpotlight();
				}
			}}
			tabIndex={0}
		>
			<ThumbnailContainer>
				<IconSmart />
			</ThumbnailContainer>

			<Content id="labelId">
				<TruncatedText>{translate('spotlight.nlsBannerTitle')}</TruncatedText>
				<Subtext>
					<TruncatedText>{translate('spotlight.nlsBannerSubtitle')}</TruncatedText>
				</Subtext>
			</Content>

			<RightElements
				onClick={(event) => {
					// If not prevent propagation, then onClick would be triggered multiple times on Item, which results in incorrect state
					event.stopPropagation();
				}}
				onKeyDown={(event) => {
					// If not prevent propagation, then onClick would be triggered multiple times on Item, which results in incorrect state
					event.stopPropagation();
				}}
			>
				<Switch
					isChecked={isNLSSearchOn}
					aria-labelledby="labelId"
					onChange={() => toggleNLSAndFocusSpotlight()}
					data-heapId="discover_spotlight-nls-switch"
				/>
			</RightElements>
		</ItemStyled>
	);
}

const ItemStyled = styled.div`
	display: flex;

	align-items: flex-start;
	margin: ${token.spacing3};
	padding: ${token.spacing3};
	background-color: #f3f2fd;
	border-radius: ${token.radiusLarge};

	&:hover {
		background-color: #eeedfc;
		cursor: pointer;
	}

	&:active {
		background-color: #f3f2fd;
	}
`;

const ThumbnailContainer = styled.div`
	flex: none;
	margin-right: ${token.spacing4};
	color: ${token.purple500};
`;

const Content = styled.div`
	${textStyles.uiTextM}

	flex: 1;
	min-width: 0;
	font-weight: 400;
	color: #031026;
`;

const Subtext = styled.div<{ $isDisabled?: boolean }>`
	${textStyles.uiTextS}

	color: ${token.colorTextMuted};
`;

const RightElements = styled.div`
	display: flex;
	flex: none;
	gap: ${token.spacing3};
	align-items: center;
	margin-left: ${token.spacing4};
`;
